import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SelectedApexMech } from '@ortho-next/nextray-core';
import { Plan } from '../../../core';
import { BaseComponent } from '../../../shared';
import { PrtApexTableComponent } from '../prt-apex-table';
import { PrtLldTableComponent } from '../prt-lld-table';
import { PrtMnsaTableComponent } from '../prt-mnsa-table';
import { PrtRecClinicMeasuresComponent } from '../prt-rec-clinic-measures';
import { PrtTemplateComponent } from '../prt-template';


/**
* Second page of PDF print.
*/
@Component({
	selector: 'print-page-two',
	templateUrl: './page-two.component.html',
	imports: [
		PrtTemplateComponent,
		PrtLldTableComponent,
		PrtApexTableComponent,
		PrtMnsaTableComponent,
		PrtRecClinicMeasuresComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrintPageTwoComponent extends BaseComponent implements OnInit {

	@Input() isDemo = false;
	@Input() today: Date | null = null;

	currentCase?: Plan;
	isMNSA = false;
	canvasSrc?: string;


	ngOnInit(): void {
		this.currentCase = this.canvasSrv.currentCase;
		this.isMNSA = !!this.eocMeasures?.eoc_ap_MNSA && this.canvasSrv.selectedApex === SelectedApexMech.femurProximal;
		this.canvasSrc = this.canvasSrv.printResult?.templating;
	}

}
